import SuccessActions from '../../components/SuccessOrderPage/SuccesActions';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(SuccessActions);
